<template>
	<input
		type="text"
		:class="variantCls.root"
		:value="value"
		:disabled="disabled"
		v-on="{
			...computedListeners,
			input: event => $emit('input', event.target.value)
		}"
	/>
</template>
i
<script>
export default {
	props: {
		variant: {
			type: String,
			default: "default"
		},
		value: {
			required: true,
			default: "",
			validator(val) {
				return val === null || typeof val === "string"
			}
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		computedListeners() {
			return this.disabled ? {} : this.$listeners
		},
		variantCls() {
			return this.$store.getters.variants("JInputText", this.variant).el
		}
	}
}
</script>
